import { render, staticRenderFns } from "./IcoSiniestro.vue?vue&type=template&id=6a627adc&scoped=true"
import script from "./IcoSiniestro.vue?vue&type=script&lang=ts"
export * from "./IcoSiniestro.vue?vue&type=script&lang=ts"
import style0 from "./IcoSiniestro.vue?vue&type=style&index=0&id=6a627adc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a627adc",
  null
  
)

export default component.exports